import SpringDeals2026Modal from 'src/components/Modals/SpringDeals2026Modal.svelte';
import { PROMOTIONS } from 'src/constants';
import { home_data } from 'src/stores/account/user';
import { get } from 'svelte/store';

export const SpringDeals2026ModalConfig = (forceShow = false) => {
	return {
		id: 'springDeals2026',
		component: SpringDeals2026Modal,
		props: {
			showModal: true,
		},
		rules: [
			{
				check: () => {
					const now = new Date().getTime();
					const homeData = get(home_data);
					const hasBeenSeen = !!homeData?.promotions?.springDeals2026;

					return (
						now >= PROMOTIONS.SPRING_DEALS_2026.START_DATE &&
						now < PROMOTIONS.SPRING_DEALS_2026.END_DATE &&
						(!hasBeenSeen || forceShow)
					);
				},
				expected: true,
			},
		],
	};
};
